export var OrdersActionTypes;
(function (OrdersActionTypes) {
    OrdersActionTypes["FETCH_ORDERS_ATTEMPT"] = "FETCH_ORDERS_ATTEMPT";
    OrdersActionTypes["FETCH_ORDERS_SUCCESS"] = "FETCH_ORDERS_SUCCESS";
    OrdersActionTypes["FETCH_ORDERS_FAILURE"] = "FETCH_ORDERS_FAILURE";
})(OrdersActionTypes || (OrdersActionTypes = {}));
